import type { RouteMatch } from '@confluence/route';

export const FORCE_TRANSITION_QUERY_PARAM = 'force_transition';

export const isForceTransition = (prevMatch: RouteMatch, currentMatch: RouteMatch): boolean => {
	const currentForceTransitionId = currentMatch?.query?.[FORCE_TRANSITION_QUERY_PARAM];
	const previousForceTransitionId = prevMatch?.query?.[FORCE_TRANSITION_QUERY_PARAM];

	return Boolean(
		currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId,
	);
};
